import dsUtils from '../../utils/utils'
import type {CompStructure, PS} from '@wix/document-services-types'
import dataModel from '../../dataModel/dataModel'

function getCompData(component: CompStructure, ps: PS, pageId: string) {
    const dataQuery = dsUtils.stripHashIfExists(component.dataQuery)
    return dataModel.getDataItemById(ps, dataQuery, pageId)
}

function isBlocksWidgetData(compData) {
    return compData?.type === 'WidgetRef' && !!compData?.appDefinitionId
}

function isBlocksWidget(component: CompStructure, ps: PS, pageId: string) {
    const compData = getCompData(component, ps, pageId)
    return isBlocksWidgetData(compData)
}

function stretchHorizontally(ps: PS, component: CompStructure, pageId: string) {
    if (!isBlocksWidget(component, ps, pageId)) {
        return true
    }

    return false
}

const mobileConversionConfig = {stretchHorizontally}

function isCrossSiteDuplicatable(ps: PS, component: CompStructure) {
    if (isBlocksWidgetData(component?.data)) {
        return false
    }
    return true
}

export default {
    shouldAutoSetNickname: false,
    mobileConversionConfig,
    canContainByStructure: true,
    canBeStretched: true,
    crossSiteDuplicatable: isCrossSiteDuplicatable
}
